import { render, staticRenderFns } from "./DocumentGroupTable.vue?vue&type=template&id=19790136&"
import script from "./DocumentGroupTable.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGroupTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports